module.exports = __webpack_public_path__ + "media/assets/images/synchronizing_gray-1eef1a1bcb4e85a66c00c4e5454abecf.png";